import dayjs from 'dayjs';
import { PeriodPreset } from '../period-picker.interface';
import { periodPresets } from '../period-picker.config';

export const parsePreset = (start: Date, end: Date): PeriodPreset | null => {
    const unit = dayjs(start).isSame(end, 'day') ? 'hour' : 'day';

    return periodPresets.find(period => {
        const to = dayjs(period.startAt()).add(period.period(), unit).endOf(unit).toDate();

        return dayjs(start).isSame(period.startAt(), unit) && dayjs(end).isSame(to, unit);
    }) || null;
};
